import type { HouseholdMemberType } from "@/domain/householdMember";

type HouseholdMemberNameType = Pick<
  HouseholdMemberType,
  "firstName" | "lastName"
>;

const normalizeHouseholdMemberName = (
  name: HouseholdMemberNameType["firstName"],
) => name?.trim().toLowerCase().normalize("NFC");

export const hasMatchingHouseholdMemberName = ({
  member,
  candidate,
}: {
  member: HouseholdMemberNameType;
  candidate: HouseholdMemberNameType;
}): boolean => {
  const firstName = normalizeHouseholdMemberName(candidate.firstName);
  const lastName = normalizeHouseholdMemberName(candidate.lastName);

  return Boolean(
    firstName &&
    lastName &&
    normalizeHouseholdMemberName(member.firstName) === firstName &&
    normalizeHouseholdMemberName(member.lastName) === lastName,
  );
};
